/* eslint-disable react/no-unknown-property */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState } from 'react';
import { Modal, Select, Button, notification, Input } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import axios from 'axios';
import { authenticateCurrentUser } from '../services/auth';
import { resetPasswordCredentials } from '../services/userManagement';

const { Option } = Select;

const EMAIL_NOTIFICATION_URL =
  process.env.REACT_APP_EMAIL_NOTIFICATION_URL || 'http://localhost:3002';

const ResetPasswordModal = (props) => {
  const {
    resetPasswordModalVisible,
    setResetPasswordModalVisible,
    resetPasswordModalLoading,
    setResetPasswordModalLoading,
    resetPasswordRecord,
    setResetPasswordRecord,
  } = props;

  const [expirySeconds, setExpirySeconds] = useState(86400); // Default 24 hours
  const [isGeneratingCredentials, setIsGeneratingCredentials] = useState(false);

  const handleCancel = () => {
    setResetPasswordRecord([]);
    setExpirySeconds(86400);
    setResetPasswordModalVisible(false);
  };

  const handleSendResetLink = async () => {
    if (!resetPasswordRecord?.email) {
      notification.error({ message: 'User email not found' });
      return;
    }

    setResetPasswordModalLoading(true);

    try {
      // Get the current logged-in user's email
      const currentUser = await authenticateCurrentUser();
      const currentUserEmail =
        currentUser?.attributes?.email || currentUser?.username || 'Administrator';

      const response = await axios.post(`${EMAIL_NOTIFICATION_URL}/pih/reset-password-link`, {
        email: resetPasswordRecord.email.toLowerCase().trim(),
        firstName: resetPasswordRecord.name?.split(' ')[0] || '',
        lastName: resetPasswordRecord.name?.split(' ').slice(1).join(' ') || '',
        creatorEmail: currentUserEmail,
        ttlSeconds: expirySeconds,
      });

      if (response.data?.success === 1) {
        notification.success({
          message: 'Reset link sent successfully!',
          description: `${resetPasswordRecord.email} will receive an email with a link to set a new password.`,
          duration: 4,
        });
        handleCancel();
      } else {
        throw new Error(response.data?.message || 'Failed to send reset link');
      }
    } catch (error) {
      console.error('Error sending reset link:', error);
      notification.error({
        message: 'Failed to send reset link',
        description: error.response?.data?.message || error.message || 'Please try again.',
      });
    } finally {
      setResetPasswordModalLoading(false);
    }
  };

  const handleCopyCredentials = async () => {
    if (!resetPasswordRecord?.email) {
      notification.error({ message: 'User email not found' });
      return;
    }

    setIsGeneratingCredentials(true);
    try {
      // Get the current logged-in user's email
      const currentUser = await authenticateCurrentUser();
      const currentUserEmail =
        currentUser?.attributes?.email || currentUser?.username || 'Administrator';

      // Get username from resetPasswordRecord
      const username =
        resetPasswordRecord.user_id ||
        resetPasswordRecord.username ||
        resetPasswordRecord.email.toLowerCase().trim();

      const result = await resetPasswordCredentials(username, resetPasswordRecord.email, currentUserEmail);

      if (result?.email && result?.password) {
        // Copy to clipboard immediately after generation
        const credentialsText = `Email: ${result.email}\nPassword: ${result.password}`;
        navigator.clipboard
          .writeText(credentialsText)
          .then(() => {
            notification.success({
              message: 'Credentials generated and copied to clipboard!',
              duration: 2,
            });
          })
          .catch(() => {
            notification.error({
              message: 'Failed to copy credentials',
            });
          });
      } else {
        throw new Error('Failed to generate reset password credentials');
      }
    } catch (error) {
      console.error('Error generating reset password credentials:', error);
      notification.error({
        message: 'Failed to generate reset password credentials',
        description: error.response?.data?.error || error.message || 'Please try again.',
      });
    } finally {
      setIsGeneratingCredentials(false);
    }
  };

  return (
    <Modal
      className="quality-modal heatprofile-modal"
      title="Reset Password"
      centered
      width={600}
      visible={resetPasswordModalVisible}
      onCancel={handleCancel}
      footer={[
        <Button
          key="cancel"
          size="large"
          onClick={handleCancel}
          disabled={resetPasswordModalLoading || isGeneratingCredentials}
        >
          Cancel
        </Button>,
        <Button
          key="copy"
          size="large"
          icon={<CopyOutlined />}
          loading={isGeneratingCredentials}
          disabled={resetPasswordModalLoading || isGeneratingCredentials}
          onClick={handleCopyCredentials}
        >
          {isGeneratingCredentials ? 'Generating...' : 'Copy Credentials'}
        </Button>,
        <Button
          key="sendLink"
          type="primary"
          size="large"
          loading={resetPasswordModalLoading}
          disabled={resetPasswordModalLoading || isGeneratingCredentials}
          onClick={handleSendResetLink}
        >
          {resetPasswordModalLoading ? 'Sending...' : 'Send Reset Link'}
        </Button>,
      ]}
    >
      <div className="reset-password-content">
        <p className="reset-password-message">
          Are you sure you want to <strong>reset the password</strong> for{' '}
          <strong>{resetPasswordRecord?.name || resetPasswordRecord?.email}</strong>?
        </p>

        <p className="reset-password-description">
          The user will receive an invite email with a secure link to set a new password. Choose how
          long that link stays valid below.
        </p>

        {resetPasswordRecord?.email && (
          <div className="reset-password-field reset-password-email-block">
            <label className="reset-password-label" htmlFor="reset-password-user-email">
              User email
            </label>
            <Input
              id="reset-password-user-email"
              value={resetPasswordRecord.email}
              readOnly
              size="large"
              aria-readonly="true"
              style={{ background: '#f5f5f5', color: '#1f2937', borderColor: '#d1d5db' }}
            />
          </div>
        )}

        <div className="reset-password-field">
          <label className="reset-password-label" htmlFor="reset-password-link-expiry">
            Link expiry time
          </label>
          <Select
            id="reset-password-link-expiry"
            value={expirySeconds}
            onChange={(value) => setExpirySeconds(value)}
            className="reset-password-select"
            dropdownClassName="reset-password-select-dropdown"
            getPopupContainer={(trigger) => trigger.parentNode}
            size="large"
            aria-label="Link expiry time"
          >
            <Option value={1800}>30 minutes</Option>
            <Option value={3600}>1 hour</Option>
            <Option value={86400}>24 hours</Option>
            <Option value={172800}>2 Days</Option>
            <Option value={604800}>7 Days</Option>
          </Select>
        </div>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
